import { Menu, MenuProps } from 'antd';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAccount } from 'wagmi';

import checkAdmin from '@/libs/checkAdmin';

function MenuList(props: MenuProps) {
  const { isConnected, address } = useAccount();
  const location = useLocation();

  const isAdmin = checkAdmin(address);

  const navItems = isConnected
    ? [
        {
          key: '/my-issues',
          label: <Link to="/my-issues">My Issues</Link>
        },
        isAdmin
          ? {
              key: '/add-issue',
              label: <Link to="/add-issue">Add Issue</Link>
            }
          : null
      ]
    : [
        {
          key: '/login',
          label: <Link to="/login">Login & Sign up</Link>
        }
      ];

  return (
    <Menu
      mode="horizontal"
      defaultSelectedKeys={[location.pathname]}
      selectedKeys={[location.pathname]}
      items={[
        {
          key: '/',
          label: <Link to="/">Issues</Link>
        },
        ...navItems
      ]}
      {...props}
    />
  );
}

export default MenuList;
